// strict-email.directive.ts
import { Directive, HostListener } from '@angular/core'
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms'

export function strictEmailValidator(control: AbstractControl): ValidationErrors | null {
  const strictEmailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})$/
  const value = control.value
  if (!value) return null // don't validate empty (let required handle empties)
  return strictEmailPattern.test(value) ? null : { email: true }
}

@Directive({
  selector: '[appStrictEmail]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: StrictEmailDirective,
      multi: true
    }
  ],
  standalone: true
})
// export class StrictEmailDirective implements Validator {
//   validate(control: AbstractControl): ValidationErrors | null {
//     return strictEmailValidator(control)
//   }
// }
export class StrictEmailDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return strictEmailValidator(control)
  }

  @HostListener('input', ['$event.target'])
  onInput(input: HTMLInputElement) {
    const value = input.value
    if (value && value !== value.toLowerCase()) {
      input.value = value.toLowerCase()
      // Update Angular form control if possible
      const nativeInput = input as any
      if (nativeInput && nativeInput.dispatchEvent) {
        nativeInput.dispatchEvent(new Event('input', { bubbles: true }))
      }
    }
  }
}
